import { render, staticRenderFns } from "./SalesReportWidgetHighlight.vue?vue&type=template&id=640eba54&scoped=true&"
import script from "./SalesReportWidgetHighlight.vue?vue&type=script&lang=js&"
export * from "./SalesReportWidgetHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640eba54",
  null
  
)

export default component.exports